import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { Modal, Button, Form } from "react-bootstrap";
import QRCode from "qrcode";
import { toast, ToastContainer } from "react-toastify";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import chaafo from "../../images/chAafo Logo.svg";
import HandiLogo from "../../images/Handi_Logo.png";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import MyContext from "../../MyContext"; //using ContextAPI to store data dynamically
const Dining = ({ userID }) => {
  
    const navigate = useNavigate();
  
  const {baseUrl} = useContext(MyContext);
  const {config}= useContext(MyContext);

  const [tables, setTables] = useState([]);
  const [qrCodes, setQrCodes] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showAddTableModal, setShowAddTableModal] = useState(false);
  const [newtableNumber, setNewTableNumber] = useState("");
  const [newTable, setNewTable] = useState({
    status: "",
    order: "",
    paymentStatus: "",
  });


  let BASIC_AUTH = "YW5sb29rQGdtYWlsLmNvbTpBbmxvb2tAMTIzNDU=";
  const addNewTable = async () => {
    // const newTableData = {
    //   id: tables.length + 1,
    //   status: newTable.status || "available",
    //   order: newTable.order || null,
    //   paymentStatus: newTable.paymentStatus || null,
    // };
    // setTables([...tables, newTableData]);
    // setShowAddTableModal(false);
    // setNewTable({ status: "", order: "", paymentStatus: "" });
    try {
      const requestBody = {
        userid: userID,
        tableNo: newtableNumber,
      };
     
      const response = await axios.post(
        `${baseUrl}/api/Order/addRestaurantTable`,
        requestBody,
        config
      );
      if (response.data.responseCode === "00") {
        toast.success(response.data.responseMessage);
        setNewTableNumber("");
        closeAddTableModal();
        fetchTableApi();
      } else {
        // Handle failure case
        toast.error(response.data.responseMessage || "Failed to add table"); // Display the error message
        setNewTableNumber("");
      }
    } catch {}
  };
  const fetchTableApi = async () => {
    try {
      const requestBody = {
        userid: userID,
      };
      
      const response = await axios.post(
        `${baseUrl}/api/Order/getRestaurantTable`,
        requestBody,
        config
      );
      // Access the response correctly
      if (response.data.responseCode === "00") {
        setTables(response.data.response); // Correctly access the response data
        // toast.success(response.data.responseMessage);
      }
    } catch (error) {
      console.error("Error fetching tables:", error); // Add error logging
      // toast.error("Failed to fetch tables.");
    }
  };


  useEffect(() => {
    fetchTableApi();
  }, []);

  const generateQRCodeURLOnly = async (
    tableId,
    retaurentName,
    qrUrl,
    whatsappNumber,
    message
  ) => {




    // const message1 = `This is Table No. ${tableId}`;
    const message1 =
      "Hello, I’m seated at Table No. 4 and would like to place my order. Thank you!";
    const phoneNumber = "919266525351";
    const whatsappLink = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(
      message
    )}`;

    try {
      const qrCodeDataUrl = await QRCode.toDataURL(whatsappLink, {
        errorCorrectionLevel: "H",
        margin: 1,
        scale: 38, // 10cm at 96dpi ≈ 378px. scale determines the image size
      });
    
      const qrImage = new Image();
      qrImage.src = qrCodeDataUrl;
    
      return new Promise((resolve) => {
        qrImage.onload = () => {
          const canvas = document.createElement("canvas");
          const sizeInPixels = 378; // 10cm = 378px at 96dpi
          canvas.width = sizeInPixels;
          canvas.height = sizeInPixels;
    
          const ctx = canvas.getContext("2d");
          ctx.drawImage(qrImage, 0, 0, sizeInPixels, sizeInPixels);
    
          const finalQRCode = canvas.toDataURL("image/png", 1.0);
          resolve(finalQRCode);
        };
      });
    }  catch (err) {
      console.error("Failed to generate QR Code", err);
      return null;
    }
  };




  
  
  
  
  



 
 

  const closeModal = () => setShowModal(false);
  const closeAddTableModal = () => setShowAddTableModal(false);

 
  


 




  
  


  
  return (
    <div className="p-4">
      <ToastContainer />
      <div className="px-4">
        <div className="d-flex justify-content-between align-items-center">
          <div className="text-center mb-4 CreateCampaign">
            Dining Order Management
          </div>
          <div className="d-flex justify-content-between align-items-center gap-3">
            <div className="d-flex justify-content-center mb-4">
              <Button
                variant="success"
                onClick={() => setShowAddTableModal(true)}
              >
                Add New Table
              </Button>
            </div>
            <div className="d-flex justify-content-center mb-4">
              <Button className="btn btn-success"   onClick={() => navigate("/Orders/QR_Code")} >
                Download QR Codes
              </Button>
              
            </div>
          </div>
        </div>
        <Modal
          show={showAddTableModal}
          onHide={closeAddTableModal}
          centered
          className="custom-modal"
        >
          <Modal.Header closeButton className="modal-header-custom">
            <Modal.Title className="modal-title-custom">
              Add New Table
            </Modal.Title>
          </Modal.Header>
          <Modal.Body className="modal-body-custom">
            <Form>
              <Form.Group>
                <Form.Label className="modal-label">
                  Enter Table Number :
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="Enter table number"
                  value={newtableNumber} // Make sure newtableNumber is defined in your state
                  onChange={(e) => setNewTableNumber(e.target.value)} // Directly set the value
                  className="form-control-custom"
                />
              </Form.Group>
            </Form>
          </Modal.Body>
          <Modal.Footer className="modal-footer-custom">
            <Button
              variant="outline-secondary"
              onClick={closeAddTableModal}
              className="modal-btn"
            >
              Close
            </Button>
            <Button
              variant="primary"
              onClick={addNewTable}
              className="modal-btn-primary"
              disabled={!newtableNumber} // Disable button if newtableNumber is empty or undefined
            >
              Add Table
            </Button>
          </Modal.Footer>
        </Modal>
   


        <div className="row dining-table-row">
          {tables.map((table) => (
            <div className="col-12 col-md-12 dining-table-col" key={table.id}>
              <div
                className={`dining-table-card ${
                  table.status !== "Open"
                    ? "dining-table-booked"
                    : "dining-table-available"
                }`}
              >
                <h3 className="dining-table-title">Table {table.tableNo}</h3>
                <p className="dining-table-status">
                  Status:{" "}
                  <span>
                    {table.status !== "Open" ? "Booked" : "Available"}
                  </span>
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default Dining;